import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { BadgeColor, BadgeSingleColorWidgetConfig } from './model';
import { resolveBadgeWidgetColors } from '../../helpers/widget-color.helper';

@Component({
  selector: 'app-badge-single-color-widget',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatTooltipModule, MatIconModule],
  templateUrl: './badge-single-color-widget.component.html',
  styleUrl: './badge-single-color-widget.component.scss',
})
export class BadgeSingleColorWidgetComponent {
  @Input() value: any = '';
  @Input() color?: BadgeColor;
  @Input() customColor?: string | undefined;
  @Input() tooltip!: string | ((value: any) => string);
  @Input() icon?: string; // Optional Material Icon name
  @Input() action?: (value: any) => void; // Optional action callback
  @Input() translate: boolean = false; // Flag to enable i18n
  @Input() translationPrefix?: string; // Translation prefix from grid (read-only)

  getDisplayValue(): string {
    return this.value ? String(this.value).toUpperCase() : '';
  }

  getBackgroundColor(): string {
    return this.getBadgeColors().backgroundColor;
  }

  getTextColor(): string {
    return this.getBadgeColors().textColor;
  }

  private getBadgeColors() {
    return resolveBadgeWidgetColors({
      customColor: this.customColor,
      color: this.color,
    });
  }

  /**
   * Get the full translation key for i18n lookup
   * If translate is true, uses translationPrefix + normalized value
   * Example: USERS_DEMO_2.USERS_TABLE.STATUS + "ACTIVE" -> USERS_DEMO_2.USERS_TABLE.STATUS.ACTIVE
   */
  get translationKeyFull(): string | null {
    if (!this.translate || !this.translationPrefix) {
      return null;
    }

    const normalizedValue = String(this.value)
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '_');

    return `${this.translationPrefix}.${normalizedValue}`;
  }

  getTooltip(): string {
    if (typeof this.tooltip === 'function') {
      return this.tooltip(this.value);
    }
    return this.tooltip || '';
  }

  onClick(event: MouseEvent): void {
    if (this.action) {
      event.preventDefault();
      event.stopPropagation();
      this.action(this.value);
    }
  }
}
